import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./HomeDate.css";
import htmlParser from "html-react-parser";


export default function Banner({ dateTime, loanOfficer, loInformation, homeDate }) {
    const imgCDNUrl = process.env.REACT_APP_CDN_URL;
  

  return (
    <>
      <div className="completedattimesectiion">
        <Container >
         
          <Row>
            <Col sm={12} md={12} lg={12} xl={12} >
            <div className="disdivdate">
             <p className="homeownershipdiv">
                {htmlParser(homeDate.dateDisclaimer)}
                </p>
                </div>
                <div >
             <p className="homeownershipdivsecond">
                {htmlParser(homeDate.joinDisclaimer)}
                </p>
                </div>
            </Col>
           
            
        
          </Row>
        </Container>
      </div>
    </>
  );
}
